import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import ApplicationUnavailable from '../pages/ApplicationUnavailable';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Router>
          <ApplicationUnavailable />
        </Router>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
